import {
  ArrayInput,
  BooleanInput,
  Edit,
  FormDataConsumer,
  NumberInput,
  SelectInput,
  SimpleForm,
  TextField,
  TextInput,
  required,
  useRecordContext,
} from "react-admin";
import { SettingTypes } from "./utils.type";
import { JsonInput } from "./create";

export function AppSettingsEdit() {
  return (
    <Edit>
      <SimpleForm>
        <NameField />
      </SimpleForm>
    </Edit>
  );
}


function NameField() {
  const record = useRecordContext();
  return (
    <>
      <SelectInput
          source="type"
          choices={Object.values(SettingTypes).map((type) => ({
            id: type,
            name: type,
          }))}
          validate={required()}
          disabled = {record?.name === "banner" }
        />
        <FormDataConsumer>
          {({ formData }) => {
            if (formData?.type) {
              switch (formData?.type) {
                case SettingTypes.NUMBER: {
                  return <NumberInput source="value" type="number" disabled = {record?.name === "banner" }  />;
                }
                case SettingTypes.BOOLEAN: {
                  return <BooleanInput source="value" disabled = {record?.name === "banner" } />;
                }
                case SettingTypes.STRING: {
                  return <TextInput source="value" disabled = {record?.name === "banner" } />;
                }
                case SettingTypes.JSON: {
                  return <JsonInput source="value" label={"Value"}  />;
                }

                case SettingTypes.ARRAY: {
                  return (
                    <ArrayInput source="value">
                      <TextInput source=""  disabled = {record?.name === "banner" }/>
                    </ArrayInput>
                  );
                }

                default: {
                  return <TextInput source="value"  disabled = {record?.name === "banner" }/>;
                }
              }
            }
          }}
        </FormDataConsumer>
        <BooleanInput
          source="isPublic"
          validate={required()}
          defaultValue={true}
          disabled = {record?.name === "banner" }
        />
        <TextInput source="description" multiline  disabled = {record?.name === "banner" }/>
    </>
  )
}
